import { createFilterOptions } from '@mui/material';
import { createFilter } from 'react-select';
import {
  fileTagLabel,
  matchesFileTagSearch,
} from '@liscio/common/file-tag-label';

const storedTag = (option) => String(option.key ?? option.value ?? option.label);

// Built on first use so importing this module never calls into (possibly mocked) libraries.
let defaultFilter;
let defaultMuiFilter;

/** Display text for a tag option or free-typed tag; the option itself is never relabelled. */
export const formatFileTagOption = (option) =>
  typeof option === 'string'
    ? fileTagLabel(option)
    : fileTagLabel(storedTag(option), option.label);

/** True when the option's label, display name or stored tag contains `input`. */
export const matchesFileTagOption = (option, input) =>
  option.label.toLowerCase().includes(input.trim().toLowerCase()) ||
  matchesFileTagSearch(storedTag(option), input);

/** react-select filter that also matches a tag option by its display name. */
export const filterFileTagOption = (option, input) => {
  defaultFilter ??= createFilter();
  return (
    defaultFilter(option, input) ||
    matchesFileTagSearch(storedTag(option.data), input)
  );
};

/** MUI Autocomplete filter that also matches a tag option by its display name or stored tag. */
export const filterFileTagMuiOptions = (options, state) => {
  defaultMuiFilter ??= createFilterOptions();
  const matched = new Set(defaultMuiFilter(options, state));
  return options.filter(
    (option) => matched.has(option) || matchesFileTagOption(option, state.inputValue),
  );
};
